module.exports = __webpack_public_path__ + "img/new.0b55e0cd.png";